module.exports = __webpack_public_path__ + "img/logo-elrosario.8c33b80c.png";